(($, Drupal) => {
  Drupal.behaviors.newsBlock = {
    attach: function attach() {
      $('.simple-block').once('add').each(function () {
        const findSwiper = $(this).find('.swiper');

        if (!findSwiper.length) {
          if ($(this).find('.swiper-button__wrapper').get(0)) {
            $(this).find('.swiper-button__wrapper').get(0).style.display = 'none';
          }
        }
      });

      $('.swiper--products').each(function (index) {
        const parentEl = $(this).closest('[data-slider="parent"]');
        const arrowPrev = parentEl.find('.swiper-button-prev').get(0);
        const arrowNext = parentEl.find('.swiper-button-next').get(0);
        const pagination = parentEl.find('.swiper-pagination').get(0);

        $(this).find('.views-row').addClass('swiper-slide');

        const swiper = new Swiper(this, {
          spaceBetween: 20,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: arrowNext,
            prevEl: arrowPrev,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            800: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          },
        });
      });

      $('.swiper--news').once('add').each(function (index) {
        const parentEl = $(this).closest('[data-slider="parent"]');
        const arrowPrev = parentEl.find('.swiper-button-prev').get(0);
        const arrowNext = parentEl.find('.swiper-button-next').get(0);
        const pagination = parentEl.find('.swiper-pagination').get(0);

        $(this).find('.slider-item').addClass('swiper-slide');

        const swiper = new Swiper(this, {
          spaceBetween: 20,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: arrowNext,
            prevEl: arrowPrev,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        });
      });

      $('.swiper--shop').once('add').each(function (index) {
        const parentEl = $(this).closest('[data-slider="parent"]');
        const arrowPrev = parentEl.find('.swiper-button-prev').get(0);
        const arrowNext = parentEl.find('.swiper-button-next').get(0);
        const pagination = parentEl.find('.swiper-pagination').get(0);
        const slideElems = $(this).find('.slider-item');

        if (slideElems.length > 4) {
          slideElems.addClass('swiper-slide');

          const swiper = new Swiper(this, {
            spaceBetween: 20,
            pagination: {
              el: pagination,
              clickable: true,
            },

            navigation: {
              nextEl: arrowNext,
              prevEl: arrowPrev,
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
              },
              600: {
                slidesPerView: 2,
                grid: {
                  rows: 1,
                },
              },
              1024: {
                slidesPerView: 3,
                grid: {
                  rows: 2,
                },
              },
              1280: {
                slidesPerView: 4,
                grid: {
                  rows: 2,
                },
              },
            },
          });
        } else {
          parentEl.find('.swiper-wrapper').addClass('shop-block__grid');
          parentEl.find('.swiper-wrapper').removeClass('swiper-wrapper');
        }
      });
    },
  };
})(jQuery, Drupal);
